import React, { useEffect, useState } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { agent } from "../../utils/agent";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import * as API from "../../utils/apiPath";
import { LOAD_ORGANIZATION_LIST_SIGNUP } from "../../utils/apiPath";
import PopupModalWithOk from "../../utils/helpers/popupModalOk";
import PropTypes from "prop-types";
import { getTranslation } from "../../utils/helpers";

const MentorSignUp2 = (props) => {

  const { title } = props;
  const { register, formState: { errors }, handleSubmit } = useForm();
  const [objective, setObjective] = useState([]);
  const [settingData, setSettingData] = useState();
  const [popupMessage, setPopupMessage] = useState("");
  const [showPopup, setShowPopup] = useState(false);

  const getObjectiveData = (page = 1) => {
    agent
      .get(LOAD_ORGANIZATION_LIST_SIGNUP + "/Mentor/objective", {})
      .then((res) => {
        setObjective(res.data.data);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const settingResponse = await agent.get(API.SETTING);
        setSettingData(settingResponse?.data?.data);
      } catch (error) {
        console.error("Failed to load settings", error);
      }
    };

    fetchSettings();
  }, []);

  const getUserId = localStorage.getItem("userId");
  const [selectedObjective, setSelectedObjective] = useState([]);
  useEffect(() => {
    document.title = title;
    const getSelectedMainAreaData = (page = 1) => {
      agent
        .get(API.GETUSERDATA + "/" + getUserId)
        .then((res) => {
          if (res.data.data.domains) {
            setSelectedObjective(res.data.data.objective.split(","));
          }
        })
        .catch((err) => {
          console.error(err);
        });
    };
    getSelectedMainAreaData();
    getObjectiveData();
  }, [title]);

  const history = useNavigate();

  const setSelectedObjectiveArray = (e) => {
    const val = e.target.value;
    let cloneSelected1 = [...selectedObjective];

    if (selectedObjective.includes((item) => item === val)) {
      cloneSelected1 = selectedObjective.filter((item) => item !== val);
    } else {
      cloneSelected1.push(val);
    }

    setSelectedObjective(cloneSelected1);
  };
  const onSubmit = (data) => {
    if (data?.objective.length > 3) {
      setPopupMessage(
        "Please select only up to three objectives for a better mentee-mentor fit"
      );
      setShowPopup(true);
    }
    else {
      data.userId = localStorage.getItem("userId");
      data.stepNumber = 3;
      data.roleId = "Mentor";
      history(`/mentor-signup-step-4`);
    }
  };

  const clearAll = () => {
    setSelectedObjective([])
  };

  return (
    <div>
      <section className="loginouter studentsteps">
        <Container>
          <Form onSubmit={handleSubmit(onSubmit)} className="mt-3">
            <Row className="align-items-center ">
              <Col md={12}>
                <div className="logininnerouter">
                  <div className="w-100">
                    <div className="loginlogo text-center mb-5 pb-4">
                      <Link to="/">
                        {settingData?.logo_path && <img src={settingData?.logo_path} alt="logo" style={{ maxWidth: '200px', maxHeight: '59px' }} />}
                      </Link>
                    </div>
                    <div className="loginform">
                      <h1>Tell us about yourself</h1>
                      <div className="steps_signup">
                        <div>
                          <span className="stepcount active">1</span>
                          <span className="stepcount active">2</span>
                          <span className="stepcount active">3</span>
                          <span className="stepcount">4</span>
                        </div>
                      </div>
                      <div className="profilescreen">
                        <h4 className="">
                          {getTranslation("objective_text")}
                        </h4>
                        <div className="businessboxouter">
                          <div className="mt-3">
                            <h5>Objective*</h5>
                            <ul className="bussinessSelect">
                              {/* {objective && */}
                              {objective.map((item, key) => (
                                <li key={item.value}>
                                  {key === 0 && (
                                    <input
                                      type="checkbox"
                                      name="objective"
                                      value={item.value}
                                      checked={selectedObjective.includes(item.value.toString())}
                                      onChange={(e) =>
                                        setSelectedObjectiveArray(e)
                                      }
                                      className={`form-check-input ${errors.objective ? "is-invalid" : ""
                                        }`}
                                      {...register("objective", { required: true })}
                                    />
                                  )}
                                  {errors.objective &&
                                    key === 0 &&
                                    errors.objective.type === "required" && (
                                      <label className="invalid-feedback text-left" htmlFor="objective">
                                        Please choose at least one objective
                                      </label>
                                    )}

                                  {key !== 0 && (
                                    <input
                                      type="checkbox"
                                      name="objective"
                                      value={item.value}
                                      checked={selectedObjective.includes(item.value.toString())}
                                      onChange={(e) =>
                                        setSelectedObjectiveArray(e)
                                      }
                                      className={`form-check-input ${errors.objective ? "is-invalid" : ""
                                        }`}
                                      {...register("objective", { required: true })}
                                    />
                                  )}
                                  <div className="selectboxouter">
                                    {item.label}
                                  </div>
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="form-group mt-3 text-center">
                        <Button
                          className="btn loginsubmit nextbtn outline me-2"
                          onClick={clearAll}
                        >
                          Clear All
                        </Button>
                        {" "}
                        <Button
                          className="btn loginsubmit nextbtn outline me-2"
                          onClick={(e) => {
                            e.preventDefault();
                            history("/mentor-signup-step-2");
                          }}
                        >
                          Previous
                        </Button>
                        <Button
                          type="submit"
                          className="btn loginsubmit nextbtn nextbtn ml-2 me-2"
                        >
                          Save & Next
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Form>
        </Container>
      </section>

      <PopupModalWithOk
        show={showPopup}
        onHide={() => setShowPopup(false)}
        message={popupMessage}
        showConfirm={false}
        staticBackdrop={true}
      />
    </div>
  );
};

MentorSignUp2.propTypes = {
  title: PropTypes.string.isRequired,
};

export default MentorSignUp2;
